/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditModel {
    getFixupPrototypeFunction() { return AuditModel.fixupPrototype; }

    static newInstance(model: Partial<AuditModel>): AuditModel {
        let obj = Object.assign(new AuditModel(), model);
        AuditModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditModel>): AuditModel {
        if (!model) return null;
        return AuditModel.newInstance(<AuditModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditModel) {
        if (!obj) return;

        models.AuditModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditModel): boolean {
        Object.setPrototypeOf(obj, AuditModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Whether audit log is enabled or not.
     */
    enabled: boolean;

    /**
     * Audit log level.
     */
    audit_level: string;

}
